// FIN-11542 — FRAML-P alert source ids (24=RunInstance, 25=RTFRAUDIAD,
// 29=RTFRAUDIAD_BATCH). Variant-vs-typology UI is gated on these only.
export const FRAML_P_SOURCE_IDS = [24, 25, 29];

export const isFramlPSource = (sourceId) =>
  sourceId !== null &&
  sourceId !== undefined &&
  sourceId !== '' &&
  FRAML_P_SOURCE_IDS.includes(Number(sourceId));

// FIN-12019 — CM stores the alert source as a string label, and on the CM route
// the AMLS unified-alert endpoint has no row for the CM-domain alert id, so
// amlsCommon.alertDetails is empty and the numeric alertSourceId is absent.
// Map the CM FRAML-P labels to their numeric ids so the variant gate still fires.
export const FRAML_P_SOURCE_LABEL_TO_ID = { RTFRAUDIAD: 25, RTFRAUDIAD_BATCH: 29 };

// Prefer the AMLS numeric source (RI route); fall back to the CM label (CM route).
export const resolveAlertSourceId = (amlsSourceId, cmSourceLabel) =>
  amlsSourceId !== null && amlsSourceId !== undefined && amlsSourceId !== ''
    ? amlsSourceId
    : FRAML_P_SOURCE_LABEL_TO_ID[cmSourceLabel];
